import SurveyInfoCard from './surveyInfoCard.container';
export default SurveyInfoCard